import { createReducer, on } from '@ngrx/store';
import {
  getOtherSideTransactionAction,
  getOtherSideTransactionsErrorAction,
  getOtherSideTransactionsSuccessAction,
  resetPayoutStateAction,
  retryWithdrawErrorAction,
  retryWithdrawSuccessAction,
  updatePayoutAction,
  updatePayoutErrorAction,
  updatePayoutStatusAction,
  updatePayoutStatusErrorAction,
  updatePayoutStatusSuccessAction,
  updatePayoutSuccessAction,
} from '../actions/other-side-transaction.actions';
import { OtherSideTransaction } from '../models/api/other-side-transaction.model';
import { StateModel } from '../models/auxiliary/state.model';

export type OtherSideTransactionState = StateModel<OtherSideTransaction>;

const INITIAL_STATE: OtherSideTransactionState = {
  data: null,
  errors: null,
  loading: false,
};

export const otherSideTransactionReducer = createReducer(
  INITIAL_STATE,
  on(resetPayoutStateAction, () => INITIAL_STATE),
  on(getOtherSideTransactionAction, () => ({
    ...INITIAL_STATE,
    loading: true,
  })),
  on(updatePayoutStatusAction, updatePayoutAction, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    getOtherSideTransactionsSuccessAction,
    retryWithdrawSuccessAction,
    updatePayoutStatusSuccessAction,
    (state, { transaction }) => ({
      ...state,
      errors: null,
      data: transaction,
      loading: false,
    }),
  ),
  on(updatePayoutSuccessAction, (state, { payout }) => ({
    ...state,
    errors: null,
    data: payout,
    loading: false,
  })),
  on(
    getOtherSideTransactionsErrorAction,
    retryWithdrawErrorAction,
    updatePayoutStatusErrorAction,
    updatePayoutErrorAction,
    (state, { errors }) => ({
      ...state,
      errors: errors,
      loading: false,
    }),
  ),
);
